import { createUseStyles } from 'react-jss';
import { Theme } from '../themes/default';

const useBannerStyles = createUseStyles((theme: Theme) => {
    return {
        wrapper: {
            position: 'relative',
            width: '100%',
            height: '80vh',
            overflow: 'hidden',
            backgroundColor: '#000',
            // [theme.breakpoints.down('md')]: {
            //     height: '100vh',
            // },
        },
        video: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            // [theme.breakpoints.down('md')]: {
            //      objectFit: 'contain',
            // },
        },
        overlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1,
        },
        playButton: {
            width: '100px',
            height: '100px',
            borderRadius: '50%',
            border: `2px solid ${theme.colors.latte_cream}`,
            backgroundColor: 'rgba(227, 203, 159, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            '&:hover': {
                backgroundColor: 'rgba(227, 203, 159, 0.95)',
            },
        },
        playIcon: {
            width: 0,
            height: 0,
            borderTop: '20px solid transparent',
            borderBottom: '20px solid transparent',
            borderLeft: `22px solid ${theme.colors.espresso_brown}`,
            marginLeft: '5px',
        },
        scrollIndicator: {
            position: 'absolute',
            bottom: '32px',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '6px',
            zIndex: 1,
        },
        mouse: {
            width: '24px',
            height: '38px',
            border: `2px solid ${theme.colors.latte_cream}`,
            borderRadius: '12px',
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '6px',
        },
        mouseDot: {
            width: '4px',
            height: '8px',
            backgroundColor: theme.colors.latte_cream,
            borderRadius: '2px',
            animation: '$scrollDot 1.4s ease-in-out infinite',
        },
        '@keyframes scrollDot': {
            '0%': { opacity: 1, transform: 'translateY(0)' },
            '100%': { opacity: 0, transform: 'translateY(10px)' },
        },
        scrollArrow: {
            width: 0,
            height: 0,
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent',
            borderTop: `10px solid ${theme.colors.latte_cream}`,
        },
        scrollText: {
            color: theme.colors.latte_cream,
            fontFamily: theme.fonts.poplar,
            fontSize: '42px',
            letterSpacing: '3px',
            textTransform: 'uppercase',
            textAlign: 'center',
            margin: 0,
            [theme.breakpoints.down('md')]: {
                fontSize: '28px',
            },
        },
    };
});

export default useBannerStyles;